import { EditOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Popconfirm,
  Row,
  Space,
  Spin,
  Tooltip,
  message,
} from 'antd';
import { useEffect,  useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { ReactComponent as Passwordkey } from '../../Images/passwordKeys.svg';
import {
  archiveUser,
  createPassword,
  fetchUserList,
  fetchUserPermissionList,
  resetUserList,
  updateUserStatus,
  fetchUserById,
} from '../../slices/user';

const ViewUser = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [userData, setUserData] = useState(null);
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const { user: currentUser } = useSelector(state => state.auth);

  const [debouncedSearch, setDebouncedSearch] = useState(null);
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(20);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [popVisible, setPopVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(
    localStorage.getItem('ManageUser') || '',
  );

  const handleEdit = data => {
    navigate(`/edit-user/${id}`);
  };
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        dispatch(fetchUserById(id))
          .unwrap()
          .then(response => {
            if (response) {
              console.log(response)
              setUserData(response?.data);
            }
          })
          .catch(error => {
            console.error('Get Failed:', error);
          });
      } catch (error) {
        console.error('');
      }
    };

    fetchUserData();
  }, [id]);
  const handleOpenModal = id => {
    setIsModalVisible(true);
    setSelectedUserId(id);
  };
  const [permissionsData, setPermissionData] = useState([]);

  useEffect(() => {
    if (id) {
      dispatch(fetchUserPermissionList({ user_id: id })).then(res => {
        if (res?.payload?.success && res.payload.data) {

          setPermissionData(res.payload.data);
        } else {
          console.error('Failed to fetch:', res);
          setPermissionData([]);
        }
      })
        .catch(err => {
          console.error('Error:', err);
          setPermissionData([]);
        })
        .finally(() => {
          setLoading(false);
        });;
    }
  }, [id]);



  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedUserId(null);
  };

  const handleStatusChange = (value, id) => {
    setSelectedRecord(id);
    setSelectedValue(value);
    setPopVisible(true);
  };

  const confirmChange = () => {
    setPopVisible(false);
    const payload = {
      id: selectedRecord.id,
      status: selectedValue,
    };
    dispatch(updateUserStatus({ payload }))
      .unwrap()
      .then(result => {
        if (result) {
          message.success(result.message);
          setPage(1);
          dispatch(resetUserList());
          dispatch(
            fetchUserList({ page, pagesize, ...(search && { search: search }) }),
          );
        } else {
          message.error(result.message);
        }
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const cancelChange = () => {
    message.info('Status change canceled');
    setPopVisible(false);
  };

  const handleSubmit = values => {
    const payload = {
      user_id: selectedUserId, // Ensure selectedUserId is set correctly
      new_password: values.new_password,
      confirm_password: values.confirm_password,
    };

    setLoading(true); // Start loading spinner

    dispatch(createPassword({ values: payload }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Password Change Successfully!');
          handleCloseModal(); // Close the modal
        }
      })
      .catch(error => {
        console.error('Error:', error);
        if (error && typeof error === 'object') {
          const messages = Object.entries(error)
            .map(([key, value]) => `${key}: ${value.join(', ')}`)
            .join('; ');
          message.error(messages || 'An unknown error occurred.');
        } else {
          message.error(error?.message || 'An unknown error occurred.');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }
    dispatch(archiveUser(id))
      .unwrap()
      .then(() => {
        message.success('User Archived Successfully!');
        dispatch(fetchUserList({ page, pagesize, search: debouncedSearch }));
        navigate('/manage-user');
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  return (
    <div>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2 style={{ margin: 0 }}>View User</h2>
            <div className="bredcrumbwrp">
              <Link to="/manage-user" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/dashboard">Home</Link> },
                  { title: <Link to="/manage-user">Users</Link> },
                  { title: 'View User' },
                ]}
              />
            </div>
          </Col>
          <Col>
            <>
              <Space size="middle">
                {currentUser.permissions.permissions.user.includes(
                  'change_user',
                ) && (
                    <>
                      <Tooltip placement="top" title="Edit">
                        <Button
                          type="primary"
                          icon={<EditOutlined style={{ color: 'white' }} />}
                          onClick={() => handleEdit(id)}
                          style={{ borderRadius: 6 }}
                        />
                      </Tooltip>
                      <Modal
                        title={
                          <div
                            style={{
                              color: '#123B66',
                              fontSize: '18px',
                              fontWeight: 'bold',
                              textAlign: 'center',
                            }}
                          >
                            Change Password
                          </div>
                        }
                        open={isModalVisible}
                        onCancel={handleCloseModal}
                        footer={[
                          <Button
                            key="cancel"
                            onClick={handleCloseModal}
                            style={{
                              backgroundColor: '#f2f2f2',
                              border: 'none',
                              color: '#333',
                              fontWeight: 'bold',
                            }}
                            disabled={loading} // Disable while loading
                          >
                            Cancel
                          </Button>,
                          <Button
                            key="save"
                            type="primary"
                            style={{
                              backgroundColor: '#123B66',
                              border: 'none',
                              fontWeight: 'bold',
                            }}
                            onClick={() => form.submit()}
                          >
                            Save
                          </Button>,
                        ]}
                        mask={false}
                        style={{
                          top: '20%',
                        }}
                      >
                        <Spin spinning={loading}>
                          <div>
                            <Form
                              onFinish={handleSubmit} // Handle form submission
                              form={form}
                              layout="vertical"
                              initialValues={{
                                new_password: '',
                                confirm_password: '',
                                user_id: selectedUserId, // Ensure selectedUserId is set correctly
                              }}
                            >
                              <Form.Item
                                name="new_password"
                                label={
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      fontSize: '14px',
                                      color: '#333',
                                    }}
                                  >
                                    New Password:
                                  </span>
                                }
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter a strong password',
                                  },
                                  {
                                    pattern:
                                      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                    message:
                                      'Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one number, and one special character.',
                                  },
                                ]}
                              >
                                <Input.Password
                                  placeholder="Please enter your password"
                                  style={{
                                    borderRadius: '5px',
                                    height: '40px',
                                    fontSize: '14px',
                                  }}
                                />
                              </Form.Item>
                              <Form.Item
                                name="confirm_password"
                                label={
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      fontSize: '14px',
                                      color: '#333',
                                    }}
                                  >
                                    Confirm Password:
                                  </span>
                                }
                                dependencies={['new_password']}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please confirm your password.',
                                  },
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (
                                        !value ||
                                        getFieldValue('new_password') === value
                                      ) {
                                        return Promise.resolve();
                                      }
                                      return Promise.reject(
                                        new Error('Passwords do not match.'),
                                      );
                                    },
                                  }),
                                ]}
                              >
                                <Input.Password
                                  placeholder="Please confirm your password"
                                  style={{
                                    borderRadius: '5px',
                                    height: '40px',
                                    fontSize: '14px',
                                  }}
                                />
                              </Form.Item>
                              <div style={{ marginTop: '10px' }}>
                                <ul
                                  style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0,
                                    fontSize: '14px',
                                    color: '#666',
                                  }}
                                >
                                  <li>- Minimum 8 characters.</li>
                                  <li>- At least one uppercase letter (A-Z).</li>
                                  <li>- At least one lowercase letter (a-z).</li>
                                  <li>- At least one digit (0-9).</li>
                                  <li>
                                    - At least one special character (@$!%*?&).
                                  </li>
                                </ul>
                              </div>
                            </Form>
                          </div>
                        </Spin>
                      </Modal>
                    </>
                  )}

                <Tooltip placement="top" title="Reset Password">
                  <Popconfirm
                    title="Are you sure you want to change the password?"
                    onConfirm={() => handleOpenModal(id)}
                    onCancel={() => 'Canceled'}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="default"
                      icon={<Passwordkey style={{ fontSize: 20 }} />}
                      style={{ borderRadius: 6 }}
                    />
                  </Popconfirm>
                </Tooltip>

                {currentUser.permissions.permissions.user.includes(
                  'delete_user',
                ) && (
                    <Tooltip placement="top" title="Archive">
                      <Popconfirm
                        title="Are you sure you want to archive this id?"
                        onConfirm={() => handleDelete(id)}
                        onCancel={() => message.info('Action cancelled')}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          type="default"
                          icon={<Archive style={{ fontSize: 20 }} />}
                          style={{ borderRadius: 6 }}
                        />
                      </Popconfirm>
                    </Tooltip>
                  )}
              </Space>
            </>
          </Col>
        </Row>
      </div>
      <div className="formwrapper">
        <Row gutter={[16, 16]} className="viewform">
          <Col xs={24} sm={12} lg={8} xl={6}>
            <label className="customlabel">Username</label>
            <div className="customvalue">{userData?.username}</div>
          </Col>
          <Col xs={24} sm={12} lg={8} xl={6}>
            <label className="customlabel">First Name</label>
            <div className="customvalue">{userData?.first_name}</div>
          </Col>
          <Col xs={24} sm={12} lg={8} xl={6}>
            <label className="customlabel">Last Name</label>
            <div className="customvalue">{userData?.last_name}</div>
          </Col>
          <Col xs={24} sm={12} lg={8} xl={6}>
            <label className="customlabel">Email</label>
            <div className="customvalue">{userData?.email}</div>
          </Col>
          <Col xs={24} sm={12} lg={8} xl={6}>
            <label className="customlabel">Phone</label>
            <div className="customvalue">+{userData?.phone}</div>
          </Col>
        </Row>

        <div style={{ marginTop: '20px' }}>
          <h3>Groups</h3>
          {userData?.groups?.length === 0 ? (
            <p>No roles available.</p>
          ) : (
            <p>{userData?.groups?.join(', ')}</p>
          )}
        </div>
      </div>

      <div style={{ marginTop: '30px' }}>
        <h3 style={{ marginLeft: '10px' }}>Permissions</h3>
        {/* <hr style={{margin: '8px 0 16px 0'}} /> */}
        <div
          style={{
            // maxHeight: 300,
            overflowY: 'auto',
            fontSize: 16,
            color: '#222',
          }}
        >
          {permissionsData.permission && permissionsData.permission.length > 0 ? (
            <ul style={{ listStyle: 'none', padding: '8px ', margin: 0 }}>
              {permissionsData.permission.map((perm, idx) => (
                <li key={idx} style={{ marginBottom: 6 }}>
                  {perm}
                </li>
              ))}
            </ul>
          ) : (
            <span>No permissions available.</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewUser;
